/* eslint-disable @typescript-eslint/no-explicit-any */

// Redacts tokens from strings and replaces with a placeholder string
const redactTokens = (function () {
  // Matches multi-part tokens that are separated by ":", "-", and "_"
  // but avoids matching trailing line numbers in call stacks Ex: ":500"
  const LEGACY_PAYMENT_TOKEN_REDACTION_REGEX =
    /\/(p|pay|payments|d|deposit|transfers|verify|receipts|crypto\/order)\/[\w$-]*(?::[\w-]*[a-zA-Z][\w-]*)*(\/.*)?/g
  // Matches universal receipt page path: receipt/<type>/<token> and redacts the token
  const RECEIPT_TOKEN_REDACTION_REGEX = /\/(receipt)\/([A-Z]+)\/([\w$:-]+)?/gi
  /**
   * Matches /f/anythingupto%3Fasdfhasdf
   * Capture group 1:'/f/'
   * Capture group 2: 'anythingupto'
   * Redacted: everything including and after the first occurrence of '%3F'
   */
  const FLOW_QUERY_PARAM_REDACTION_REGEX = /(\/f\/)(.+?(?=%3F))(.*)/gi
  return function (url: string, redaction = 'REDACTED') {
    return (
      url &&
      url
        .replace(LEGACY_PAYMENT_TOKEN_REDACTION_REGEX, `/$1/${redaction}$2`)
        .replace(RECEIPT_TOKEN_REDACTION_REGEX, `/$1/$2/${redaction}`)
        .replace(FLOW_QUERY_PARAM_REDACTION_REGEX, `$1$2?${redaction}`)
        .replace(/\/(app\/verify-email)\/([0-9A-Z]+)/gi, '/$1/TOKEN')
        .replace(/\/(app\/|reward\/)(?!verify-email)\w+(\/.*)?/g, '/$1REWARD_CODE$2')
        .replace(/\/\$\w+(\/|:|\s|$)/g, '/$CASHTAG$1')
        .replace(/%2F%24\w+(%2F|:|\s|$)/g, '%2F%24CASHTAG$1')
        .replace(/nonce-[A-Za-z0-9+/=]+/gi, 'nonce-NONCEVALUE')
    ) // Cashtag Profile URLs
  }
})()

// Recursively redacts tokens from any strings in the object and subobjects
// Modifies original object.
// Visits child arrays and objects.
const redactTokensRecursive = function (
  obj: Partial<{ [key: string]: any }> | null,
  /** @type {Array<any>}*/ visited: Array<any> = []
) {
  if (!obj) {
    return
  }
  visited.push(obj)

  Object.keys(obj).forEach(prop => {
    if (prop === 'file' && obj[prop] && obj[prop].indexOf('.js') > 0) {
      // Don't sanitize javascript file names like `/cash/app/activity.js:213123`
      return
    }
    const childObj = obj[prop]
    if (typeof childObj === 'string') {
      try {
        obj[prop] = redactTokens(childObj)
      } catch (e) {
        /* Swallow error to prevent breaking the UI.
         * Adding a logger.info() creates a circlular reference.
         */
      }
    } else if ((Array.isArray(childObj) || typeof childObj === 'object') && !visited.includes(childObj)) {
      redactTokensRecursive(childObj, visited)
    }
  })
}

export { redactTokens, redactTokensRecursive }
